<template>
  <h1>Esta es la pagina de Escolares</h1>
</template>

<script>
export default {};
</script>

<style></style>
